import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as api from "../api";

// NOVO: Importa os componentes e estilos de react-pdf
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// NOVO: Configura o worker de pdfs. ESSA LINHA É CRÍTICA!
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const API_URL = process.env.REACT_APP_API_URL;

const getTextColorForBackground = (hexColor) => {
  if (!hexColor) return "#111827";
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#111827" : "#FFFFFF";
};

function Collection() {
  const [pdfs, setPdfs] = useState([]);
  const [headerColor, setHeaderColor] = useState("#FFFFFF");
  const [pageTitle, setPageTitle] = useState("");
  const { collectionId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [numPages, setNumPages] = useState({});

  // NOVO: Ref para o elemento que contém o PDF
  const containerRef = React.useRef(null);
  // NOVO: Estado para armazenar a largura do contêiner
  const [containerWidth, setContainerWidth] = useState(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    setTimeout(updateWidth, 100);
    //updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [containerRef]);

  useEffect(() => {
    const fetchPdfs = async () => {
      if (collectionId) {
        try {
          setIsLoading(true);
          setError(null);
          const response = await api.getCollectionPdfs(collectionId);
          const fetchedPdfs = response.data.pdfs;
          const pdfOrder = response.data.pdf_order;

          if (pdfOrder && pdfOrder.length > 0) {
            const orderMap = pdfOrder.reduce((acc, filename, index) => {
              acc[filename] = index;
              return acc;
            }, {});
            fetchedPdfs.sort((a, b) => orderMap[a.filename] - orderMap[b.filename]);
          }

          setPdfs(fetchedPdfs);
          setHeaderColor(response.data.header_color);
          setPageTitle(response.data.page_title);
        } catch (err) {
          console.error("Erro ao buscar PDFs da coleção:", err);
          setError("Não foi possível carregar os PDFs. Tente novamente mais tarde.");
          setPdfs([]);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchPdfs();
  }, [collectionId]);

  // NOVO: Função para obter o número de páginas do PDF
  function onDocumentLoadSuccess({ numPages: newNumPages }) {
    setNumPages(prev => ({ ...prev, [this.key]: newNumPages }));
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <p className="text-center text-gray-500 bg-white p-6 rounded-lg shadow-md">
          A carregar PDFs...
        </p>
      );
    }

    if (error) {
      return (
        <p className="text-center text-red-500 bg-white p-6 rounded-lg shadow-md">
          {error}
        </p>
      );
    }

    if (pdfs.length === 0) {
      return (
        <p className="text-center text-gray-500 bg-white p-6 rounded-lg shadow-md">
          Nenhum PDF encontrado nesta coleção.
        </p>
      );
    }

    return (
      <div className="w-full space-y-12">
        {pdfs.map((pdf) => (
          <div key={pdf.url} className="w-full flex flex-col items-center">
            <div ref={containerRef} className="w-full h-auto bg-white rounded-xl shadow-2xl overflow-hidden">
              {containerWidth && (
              <Document
                file={pdf.url}
                onLoadSuccess={onDocumentLoadSuccess.bind({ key: pdf.url })}
                loading="A carregar PDF..."
              >
                {Array.from(new Array(numPages[pdf.url]), (el, pageIndex) => (
                  <Page
                    key={`page_${pageIndex + 1}`}
                    pageNumber={pageIndex + 1}
                    renderTextLayer={false}
                    width={containerWidth}
                  />
                ))}
              </Document>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const textColor = getTextColorForBackground(headerColor);

  return (
    <div className="bg-gray-100 min-h-screen font-sans">
      <div
        className="absolute top-0 left-0 w-full h-1/2 transition-colors duration-500"
        style={{ backgroundColor: headerColor }}
      />
      <div className="relative z-10">
        <div className="max-w-4xl mx-auto p-4 sm:p-8">
          <header className="text-center pt-12 pb-8">
            <h1
              className="text-4xl sm:text-5xl font-bold"
              style={{ color: textColor }}
            >
              {pageTitle}
            </h1>
          </header>
          <main className="flex-grow flex flex-col items-center justify-center w-full">
            {renderContent()}
          </main>
          <footer className="py-8 text-center">
            TBM Têxtil
          </footer>
        </div>
        </div>
    </div>
  );
}

export default Collection;